/* Czech counts three ways and the tiles print a count under every one of them,
   so "1 materiálů" would be visible on the first page of the portal.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md. */

export function plural(n: number, ui: (key: string) => string): string {
  const key = n === 1 ? "count.one" : n < 5 ? "count.few" : "count.many";
  return `${n} ${ui(key)}`;
}
